import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";
import { Link, useNavigate } from "react-router-dom";

const Header = ({ t }: any) => {
  const [showIndustries, setShowIndustries] = useState(false);

  const [visible, setVisibility] = useState(false);
  const navigate = useNavigate();

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };
  

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      navigate(`/${id}`);
    };

          {/* <CustomNavLinkSmall 
        onMouseEnter={() => setShowIndustries(true)} 
        onMouseLeave={() => setShowIndustries(false)}
      >
        <Span>{t("Industries")}</Span>
        {showIndustries && (
          <div className="dropdown-menu">
            <div className="dropdown-item" onClick={() => navigate('/parking_operations')}>{t("Parking Operations")}</div>
            <div className="dropdown-item" onClick={() => navigate('/industry1')}>{t("Valet Operations")}</div>
            <div className="dropdown-item" onClick={() => navigate('/industry2')}>{t("Hotel Operations")}</div>
          </div>
        )}
      </CustomNavLinkSmall> */}
    
    return (
      <>

        <CustomNavLinkSmall onClick={() => navigate('/get_started')}>
          <Span>{t("Get Started")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => navigate('/sign_in')}>
          <Span>{t("Sign In")}</Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  const MenuItemExpand = () => {
    const scrollTo = (id: string) => {
      navigate(`/${id}`);
    };
    
    return (
      <>
        <CustomNavLinkSmall onClick={() => navigate('/get_started')}>
          <Span>{t("Get Started")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => navigate('/sign_in')}>
          <Span>{t("Sign In")}</Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.svg" width="200px" height="64px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} visible={visible} onClose={onClose}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={onClose}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItemExpand />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);